<template>
<div class="d-flex w-100">
  <div class="menu__item menu__item--column300">
    <div class="menu__title">Retirement village options</div>
    <ul class="menu__list-type1">
      <li v-for="link in villageLinks">
        <a class="menu__link-type1" :href="link.url">{{ link.value }}</a>
      </li>
    </ul>
  </div>
  <div class="menu__item menu__item--column300 ml-6">
    <div class="menu__title">Rest home options</div>
    <ul class="menu__list-type1">
      <li v-for="link in restHomeLinks">
        <a class="menu__link-type1" :href="link.url">{{ link.value }}</a>
      </li>
    </ul>
  </div>
</div>
</template>
<script setup>
const villageLinks = {
  independentLiving: {
    url: '/independent-living',
    value: 'Independent Living',
  },
  assistedLiving: {
    url: '/assisted-living',
    value: 'Assisted Living',
  },
};
const restHomeLinks = {
  restHomeCare: {
    url: '/rest-home-care',
    value: 'Rest Home Care',
  },
  hospitalCare: {
    url: '/hospital-care',
    value: 'Hospital Care',
  },
  dementiaCare: {
    url: '/dementia-care',
    value: 'Dementia Care',
  },
  respiteCare: {
    url: '/respite-care',
    value: 'Respite Care',
  },
  dayCare: {
    url: '/day-care',
    value: 'Day Care',
  },
};
</script>
